var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-parent is-half" }, [
    _c("article", { staticClass: "tile is-child box" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Consumbles")]),
      _c("p", { staticClass: "subtitle" }, [
        _vm._v("To change values, add a new version"),
      ]),
      _c("div", { staticClass: "field is-horizontal is-pulled-right" }, [
        _vm._m(0),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field has-addons has-addons-right" }, [
            _c("div", { staticClass: "control" }, [
              _c("div", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedIndex,
                        expression: "selectedIndex",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedIndex = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.versionList, function (version) {
                    return _c(
                      "option",
                      { key: version, domProps: { value: version } },
                      [_vm._v(_vm._s(version))]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _c("div", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary tooltip",
                  attrs: {
                    disabled: _vm.isEditValues,
                    "data-tooltip": "Add new values",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addNewList()
                    },
                  },
                },
                [_vm._m(1)]
              ),
            ]),
            _c("div", { staticClass: "control ml-2" }, [
              !_vm.isEditValues
                ? _c(
                    "button",
                    {
                      staticClass: "button is-primary tooltip",
                      attrs: { "data-tooltip": "Click to Edit Values" },
                      on: {
                        click: function ($event) {
                          return _vm.editValues(_vm.isEditValues)
                        },
                      },
                    },
                    [_vm._m(2)]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "button is-danger tooltip",
                      attrs: {
                        disabled: _vm.isError.isError,
                        "data-tooltip": "Cancel Edit",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.editValues(_vm.isEditValues)
                        },
                      },
                    },
                    [_vm._m(3)]
                  ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "table",
        { staticClass: "table is-bordered is-striped is-narrow is-fullwidth" },
        [
          _vm._m(4),
          _c(
            "tbody",
            _vm._l(_vm.selectedList, function (consumable) {
              return _c("tr", { key: consumable.consumablesId }, [
                _c("td", [_vm._v(_vm._s(consumable.description))]),
                _c("td", [_vm._v(_vm._s(consumable.category))]),
                _vm.isEditValues
                  ? _c("td", [
                      _c("div", { staticClass: "field-body" }, [
                        _c("div", { staticClass: "field" }, [
                          _c(
                            "div",
                            { staticClass: "control" },
                            [
                              _c("vue-numeric", {
                                staticClass: "input has-text-right",
                                class: {
                                  "is-danger":
                                    _vm.isEditValues && consumable.value <= 0,
                                },
                                attrs: { min: 0, precision: 2 },
                                model: {
                                  value: consumable.value,
                                  callback: function ($$v) {
                                    _vm.$set(consumable, "value", $$v)
                                  },
                                  expression: "consumable.value",
                                },
                              }),
                              _vm.isEditValues && consumable.value <= 0
                                ? _c(
                                    "span",
                                    { staticClass: "help is-danger" },
                                    [_vm._v(_vm._s(_vm.errorMessage))]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                !_vm.isEditValues
                  ? _c("td", { staticClass: "has-text-right" }, [
                      _vm._v(_vm._s(consumable.value.toFixed(2))),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Version")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-lead-pencil mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Description")]),
        _c("th", [_vm._v("Category")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("Value")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }